module.exports = __webpack_public_path__ + "img/BAU Seniors_10.6e981661.jpg";